module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1600.1ef49659.svg";